import { Controller } from "@hotwired/stimulus"

// The financial disclosure form (TMS-1704), shared by /settings/disclosures and the
// Apply Disclosures step.
//
// - `reveal` targets show while a checked radio or checkbox named data-reveal-name has
//   one of the space-separated data-reveal-value values; hidden fields are disabled so
//   they are not submitted.
// - Relationship rows are added from the `rowTemplate` (its NEW_ROW placeholder becomes
//   a unique index) with no cap. Removing a saved row marks it `_destroy` and hides it.
// - `edit` toggles the form open from the read-only summary.
export default class extends Controller {
  static targets = ["reveal", "rows", "rowTemplate", "form", "summary"]

  connect() {
    this.sync()
  }

  sync() {
    this.revealTargets.forEach((target) => {
      if (target.closest("[data-removed]")) return

      const { revealName, revealValue } = target.dataset
      const values = revealValue.split(" ")
      const shown = Array.from(this.element.querySelectorAll(`input[name="${CSS.escape(revealName)}"]`))
        .some((input) => input.checked && values.includes(input.value))

      target.hidden = !shown
      target.querySelectorAll("input, textarea, select").forEach((field) => {
        if (!field.closest("template")) field.disabled = !shown
      })
    })
  }

  addRow() {
    const html = this.rowTemplateTarget.innerHTML.replaceAll("NEW_ROW", `${Date.now()}${Math.floor(Math.random() * 1000)}`)
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
    this.rowsTarget.lastElementChild?.querySelector("input[type='text']")?.focus()
    this.sync()
  }

  removeRow(event) {
    const row = event.currentTarget.closest("[data-relationship-row]")
    if (!row) return

    const destroy = row.querySelector("input[name$='[_destroy]']")
    if (destroy && row.querySelector("input[name$='[id]']")) {
      destroy.value = "1"
      row.dataset.removed = "true"
      row.hidden = true
      row.querySelectorAll("input[required], textarea[required]").forEach((field) => { field.required = false })
    } else {
      row.remove()
    }
  }

  edit() {
    if (this.hasFormTarget) this.formTarget.hidden = false
    if (this.hasSummaryTarget) this.summaryTarget.hidden = true
    this.formTarget?.querySelector("input:not([type='hidden'])")?.focus()
  }

  cancelEdit() {
    if (this.hasFormTarget) this.formTarget.hidden = true
    if (this.hasSummaryTarget) this.summaryTarget.hidden = false
  }
}
